export default __webpack_public_path__ + "static/media/bjm.57c2264f.jpg";